module.exports = __webpack_public_path__ + "static/media/HypothesesStructured.4fa4639a.png";